export default "__VITE_ASSET__CGwpq5Fe__"